export default "__VITE_ASSET__b773d58b__"